import React, { useState } from "react";
import Drawer from "components/common/Drawer";
import { DrawerBody } from "static/coreStyles/global.styled";
import DropdownInputContainer from "components/common/DropdownInputContainer";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as categoryActions from "store/Category/actions";
import { getScope } from "utility/helperFunctions";
import swal from "sweetalert";

function CategoryApplicationsDrawer(props) {
  const [selectedApps, setSelectedApps] = useState([]);
  const [invalid, setInvalid] = useState(false);
  const [loader, setLoader] = useState(false);

  const applications = Object.keys(
    props.CategoryDetail && props.CategoryDetail.allApps
  )
    .filter(
      (option) =>
        props.CategoryDetail.allApps[option].subCategoryIds.indexOf(
          props.subCategory.id
        ) > -1
    )
    .map((option) => {
      return {
        value: option,
        label: props.CategoryDetail.allApps[option].name
      };
    });

  let defaultApps =
    props.subCategory &&
    props.subCategory.apps &&
    props.subCategory.apps.map((app) => {
      return { value: app, label: props.CategoryDetail.allApps[app].name };
    });

  function validateForm() {
    if (
      (selectedApps &&
        selectedApps.length < 1 &&
        defaultApps &&
        defaultApps.length < 1) ||
      !selectedApps
    ) {
      setInvalid(true);
      return false;
    }
    return true;
  }

  function submitForm() {
    if (validateForm()) {
      setLoader(true);
      let payload = {
        scope: getScope(true),
        sectionType: 3,
        apps:
          selectedApps && selectedApps.length
            ? selectedApps.map((app) => app.value)
            : defaultApps
            ? defaultApps.map((app) => app.value)
            : [],
        subCategoryId: props.subCategory.id
      };
      props
        .updateCategoryDetailRequest(props.categoryId, payload)
        .then((res) => {
          if (res.error) {
            setLoader(false);
            swal({
              title: "Oops!",
              text: res.error.message,
              icon: "error"
            });
          } else {
            setLoader(false);
            props.getCategoryDetailRequest(props.categoryId);
            props.getCategoryListRequest();
            props.closeDrawer();
          }
        });
    }
  }
  return (
    <Drawer
      title={props.subCategory.name}
      width="500px"
      show={props.show}
      closeDrawer={props.closeDrawer}
      footerText="Save"
      loader={loader}
      onSave={submitForm}
    >
      <DrawerBody>
        <DropdownInputContainer
          title="Select Applications"
          defaultValue={defaultApps}
          options={applications}
          passSelectedValues={(values) => {
            defaultApps = [];
            setSelectedApps(values);
          }}
          multi
          edit
          invalid={invalid && !selectedApps}
        />
      </DrawerBody>
    </Drawer>
  );
}
export default connect(
  ({ Category }) => ({ ...Category }),
  (dispatch) => bindActionCreators({ ...categoryActions }, dispatch)
)(CategoryApplicationsDrawer);
